import axiosInstance from '../../../../config/axiosInstance';
const LockReleaseService = {
    async GetModuleLockRecods(redirectCallback, ModuleID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetModuleLockRecods?ClientID=${ClientID}&ModuleID=${ModuleID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetLockReleaseID(redirectCallback, ModuleID, ID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetLockReleaseID?ClientID=${ClientID}&ModuleID=${ModuleID}&ID=${ID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async LockReleaseByUserID(redirectCallback, ModuleID) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const UserID = localStorage.getItem("UserID");
            const response = await axiosInstance.get(`/Setup/LockReleaseByUserID?ClientID=${ClientID}&ModuleID=${ModuleID}&UserID=${UserID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetLockModuleRecord(redirectCallback) {
        try {
            const ClientID = localStorage.getItem('CompanyID');
            const response = await axiosInstance.get(`/Setup/GetLockModuleRecord?ClientID=${ClientID}`);
            return response.data;
        } catch (error) {
            if (error.response.data.message == "Invalid token") {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },

};

export default LockReleaseService;